var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3202_18345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93359 0.0791016C13.3513 0.0791016 16.9336 3.66051 16.9336 8.07909C16.9336 12.4968 13.3513 16.0791 8.93359 16.0791C4.515 16.0791 0.933594 12.4968 0.933594 8.07909C0.933594 3.66051 4.515 0.0791016 8.93359 0.0791016Z",
    fill: "#EF5854"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3202_18345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.625 8.37745C4.625 8.52562 4.74512 8.64574 4.89329 8.64574H5.89606C6.04423 8.64574 6.16434 8.52562 6.16434 8.37745V5.03488C6.16434 4.88671 6.04423 4.76659 5.89606 4.76659H4.89329C4.74512 4.76659 4.625 4.88671 4.625 5.03488V8.37745ZM11.0902 4.76659H7.04837C6.9002 4.76659 6.78008 4.88671 6.78008 5.03488V8.77969C6.78008 8.8372 6.79856 8.89318 6.83278 8.93938L7.67752 10.0798C7.70321 10.1145 7.72015 10.1548 7.72691 10.1974L7.97677 11.7721C7.99835 11.9039 8.07171 12.0243 8.18356 12.1116C8.2954 12.1989 8.43831 12.2472 8.58635 12.2478H8.62729C8.87217 12.2476 9.10695 12.1599 9.28011 12.0041C9.45327 11.8483 9.55065 11.6369 9.5509 11.4166V10.0224C9.5509 9.87418 9.67102 9.75407 9.81919 9.75407H12.0138C12.3403 9.7537 12.6533 9.63681 12.8842 9.42904C13.115 9.22127 13.2449 8.93957 13.2453 8.64574V6.70617C13.2447 6.19194 13.0174 5.69894 12.6134 5.33533C12.2094 4.97172 11.6616 4.76718 11.0902 4.76659Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3202_18345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.933594 0.0791016)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3202_18345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9,
    fill: "white",
    transform: "matrix(1 0 0 -1 3.93359 13.0791)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs_down.2f9f3766fad7f51a12975d8876b9257c.svg";
export { ForwardRef as ReactComponent };